// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"Carousel__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Carousel/Carousel.scss
 ** module id = 906
 ** module chunks = 1
 **/